export const AUTOCOMPLETE = 'autocomplete';
